eSocial.ComparadorDeAuditorias = (function () {
    $(document).ready(function () {
        $(document).trigger("ComparadorReady");
    });

    // URLSearchParams não funciona não Internet Explorer 11
    // A função abaixo tem o mesmo objetivo que ela estava fazendo
    // no código abaixo, mas funciona no IE11.

    var URLSearchParamsInternal = function (name) {
        var regex = new RegExp('[?&]' + name + '=([^&#]*)');
        var results = regex.exec(window.location.href);
        return results ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
    };
    
    var comparar = function (elementId) {
        var desenvolvedor = URLSearchParamsInternal('desenvolvedor');
        var handleOrigem = URLSearchParamsInternal('origem');
        var handleDestino = URLSearchParamsInternal('destino');

        var leiauteOrigem = URLSearchParamsInternal('origemLeiaute');
        var leiauteDestino = URLSearchParamsInternal('destinoLeiaute');
        var competenciasOrigem = URLSearchParamsInternal('origemCompetencias');
        var competenciasDestino = URLSearchParamsInternal('destinoCompetencias');
        var tipoOrigem = URLSearchParamsInternal('origemTipo');
        var tipoDestino = URLSearchParamsInternal('destinoTipo');
        var dataOrigem = URLSearchParamsInternal('origemData');
        var dataDestino = URLSearchParamsInternal('destinoData');

        $("#auditoriaOrigem").html(`${handleOrigem} | ${leiauteOrigem} | ${tipoOrigem} | ${competenciasOrigem} | ${dataOrigem}`);
        $("#auditoriaDestino").html(`${handleDestino} | ${leiauteDestino} | ${tipoDestino} | ${competenciasDestino} | ${dataDestino}`);

        var metodo = desenvolvedor === '1' ? "BuscarXmlsDesenvolvedor" : "BuscarXmlsUsuario";

        AGA.Ajax.callWebMethodBlocked(metodo, {
            origem: handleOrigem,
            destino: handleDestino
        }, function (data) {
            if (data && data.d) {
                montarComparador(data.d["origem"], data.d["destino"], elementId);
            } else {
                alert("Nenhum XML retornado.");
            }
        }, function (data, message) {
            alert("Erro ao buscar as auditorias: " + message);
        });
    };

    var montarComparador = function (conteudoOrigem, conteudoDestino, elementId) {
        conteudoOrigem = eSocial.FormatadorDeXml.formatXml3Th(conteudoOrigem);
        conteudoDestino = eSocial.FormatadorDeXml.formatXml3Th(conteudoDestino);

        import('ace-diff/dist/ace-diff.min').then(function (module) {
            let diff = module.default;
            new diff({
                element: elementId,
                left: { editable: false, copyLinkEnabled: false, content: conteudoOrigem },
                right: { editable: false, copyLinkEnabled: false, content: conteudoDestino }
            });
        });
    };

    var abrirComparador = function (origem, destino) {

        if (origem == undefined || destino == undefined) {
            console.error("É necessário definir o handle de origem e o handle de destino.");
            return;
        }

        Benner.ModalPage.show({
            url: $("#Wes2008ApplicationPath").val() + "aga/e/eSocial/comparadorAuditorias.aspx?desenvolvedor=1&imp=1&origem=" + origem + "&destino=" + destino,
            id: "modalComparadorAuditoriasESocial",
            size: "fullpage",
            height: 720,
            title: "Comparador de auditorias do eSocial"
        });
    };
    
    return {
        comparar: comparar,
        abrirComparador: abrirComparador
    };
})();